import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=14a601f9"
import script from "./Warning.vue?vue&type=script&lang=ts"
export * from "./Warning.vue?vue&type=script&lang=ts"
import style0 from "./Warning.vue?vue&type=style&index=0&id=14a601f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports